var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/QRCode.tsx
import { QRCode as QRCodeCore } from "@getstep/qrcode-core";
import React from "react";
var QRCode = (_a) => {
  var _b = _a, {
    size,
    components: {
      Svg = "svg",
      Defs = "defs",
      LinearGradient = "linearGradient",
      Stop = "stop",
      G = "g",
      Rect = "rect",
      Polygon = "polygon",
      Circle = "circle",
      ClipPath = "clipPath",
      Image = "image",
      Path = "path"
    } = {},
    "data-testid": testId,
    width,
    height,
    className
  } = _b, restOfProps = __objRest(_b, [
    "size",
    "components",
    "data-testid",
    "width",
    "height",
    "className"
  ]);
  return /* @__PURE__ */ React.createElement(QRCodeCore, __spreadProps(__spreadValues({}, restOfProps), {
    "data-testid": testId,
    width,
    height,
    className,
    size,
    components: {
      Svg,
      Defs,
      LinearGradient,
      Stop,
      G,
      Rect,
      Polygon,
      Circle,
      ClipPath,
      Image,
      Path
    }
  }));
};
export {
  QRCode
};
//# sourceMappingURL=index.js.map
